{
  "type": "FeatureCollection",
  "name": "ground_level_outline",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG::3857"
    }
  },
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -9753624.759478115,
                5140894.120713461
              ],
              [
                -9753627.263055293,
                5141029.316713676
              ],
              [
                -9753607.058847541,
                5141029.665062087
              ],
              [
                -9753607.063939754,
                5141025.976314691
              ],
              [
                -9753522.679233605,
                5141027.535322215
              ],
              [
                -9753522.9851005,
                5141045.864679184
              ],
              [
                -9753508.450758735,
                5141046.102575664
              ],
              [
                -9753508.813267646,
                5141070.379344492
              ],
              [
                -9753463.556295408,
                5141071.251631579
              ],
              [
                -9753463.13714448,
                5141047.031504756
              ],
              [
                -9753448.410219844,
                5141047.258072832
              ],
              [
                -9753447.97974051,
                5141028.996686283
              ],
              [
                -9753363.97362249,
                5141030.378862222
              ],
              [
                -9753364.081583722,
                5141034.230408727
              ],
              [
                -9753343.803741354,
                5141034.615574449
              ],
              [
                -9753342.865740685,
                5140975.045279594
              ],
              [
                -9753335.70518932,
                5140975.147719682
              ],
              [
                -9753335.8661858,
                5140981.185087659
              ],
              [
                -9753315.537617564,
                5140981.63606781
              ],
              [
                -9753314.92856138,
                5140953.619483319
              ],
              [
                -9753335.383196361,
                5140952.769209048
              ],
              [
                -9753335.62469108,
                5140958.565082306
              ],
              [
                -9753342.406629387,
                5140958.822250495
              ],
              [
                -9753341.31149256,
                5140899.4110779315
              ],
              [
                -9753341.26617895,
                5140897.779787815
              ],
              [
                -9753361.498707715,
                5140897.417278899
              ],
              [
                -9753361.521364525,
                5140899.071225817
              ],
              [
                -9753361.622032342,
                5140903.625476609
              ],
              [
                -9753445.578118956,
                5140902.073252767
              ],
              [
                -9753445.283580465,
                5140883.290759662
              ],
              [
                -9753459.738623409,
                5140882.9509075545
              ],
              [
                -9753459.240173655,
                5140856.872922553
              ],
              [
                -9753505.233492121,
                5140855.989307068
              ],
              [
                -9753505.75459869,
                5140882.135262494
              ],
              [
                -9753520.005730372,
                5140881.840724009
              ],
              [
                -9753520.436209707,
                5140900.713844343
              ],
              [
                -9753604.649909299,
                5140899.149926858
              ],
              [
                -9753604.515620952,
                5140894.47189398
              ],
              [
                -9753624.759478115,
                5140894.120713461
              ]
            ]
          ]
        ]
      }
    }
  ]
}
